<template>
<div>
  <!-- Live行为数据 -->
  <el-card>
    <div class="blocked_logs_page">
    <h1>Live行为数据</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
      
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

    </div>
    <div class="user-options clearfix">
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="isPay"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isPays"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-table
    class="display-type"
        :data="tableList"
        style="width: 100%"
        border
        v-loading="login1"
      >
        <el-table-column align="center" fixed prop="date" label="日期" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="newUser" label="新增人数" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="dauUser" label="活跃人数" width="150"  sortable>
        </el-table-column>
        
         <el-table-column align="center" prop="newPayUser" label="新增付费人数" width="150" sortable>
        </el-table-column>
         <el-table-column align="center" prop="dauPayUser" label="活跃付费人数" width="150" sortable>
        </el-table-column>
         
        <!-- <el-table-column align="center" prop="openLiveUsers" label="开播人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="openLiveCount" label="开播场次" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="openLiveTime" label="开播总时长" width="150" sortable>
        </el-table-column> -->
        <el-table-column align="center" prop="intoLiveUsers" label="进入Live人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveCount" label="进入Live次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLivePayUser" label="进入Live付费人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="intoLiveAvgCount" label="人均进入Live次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="firstRecharge" label="首充付费人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payUsers" label="付费人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payCount" label="付费次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="payMoney" label="付费金额"  sortable width="140">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgUsers" label="发言人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="sendMsgCount" label="发言次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftUsers" label="送礼人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCount" label="送礼次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="giveGiftCost" label="送礼总消耗"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callUsers" label="拨打通话人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="validCallUsers" label="有效拨打人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessUser" label="成功接听人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCount" label="拨打通话次数"  sortable width="150">
        </el-table-column>
        
        <el-table-column align="center" prop="validCallCount" label="有效拨打次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callSuccessCount" label="成功接听次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callCost" label="扣费金额"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="callTimes" label="通话时长"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="remainRoomTime" label="房间停留总时长"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="remainRoomAvgTime" label="人均停留时长"  sortable width="150">
        </el-table-column>
      </el-table>
      <!-- <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
    </div>
    
  </el-card>
  <Live></Live>
  <!-- 直播间在线时长分布 -->
  <el-card >
       <el-row>
          <h1>直播间在线时长分布</h1>
       </el-row>
        <el-date-picker
          v-model="platformData_"
         type="date"
          align="right"
          unlink-panels
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button type="primary" @click="user_roomOnlineStat" :loading="loing">查询</el-button>
        <CustomBar 
        element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				v-loading="loing"
				:options="barOptions"
				class="bar"
				width="100%"></CustomBar>
  </el-card>
  <!-- renshu -->
  <Cusbor></Cusbor>
  </div>
</template>

<script>
import download from '@/utils/download.js'
import Cusbor from './action_/timeBox'
import CustomBar from '@/components/CustomBar'
import Live from './action_/live'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  components: {
    CustomBar,
    Cusbor,
    Live
  },
  data() {
    return {
      loing: false,
      login1: false,
      platformData_: datainfor(1),
      barOptions: {
        xAxis: {
          name: '时间',
          type: 'category',
          data: [
            '<5min',
            '5-10min',
            '10-20min',
            '20-40min',
            '40-60min',
            '1-2h',
            '2-4h',
            '4-8h',
            '8-12h',
            '12h>'
          ]
        },
        yAxis: {
          name: '人数',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    color: 'black',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      },
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: 0,
      userTypes: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      isPay: 0,
      isPays: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '非付费用户',
          value: 1
        },
        {
          label: '付费用户',
          value: 2
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
    this.user_roomOnlineStat()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_action,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType,
          isPay:this.isPay,
          page: this.page
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    async user_roomOnlineStat() {
      this.loing = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_roomOnlineStat,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          startDate: this.platformData_,
          endDate: this.platformData_
        }
      })
      if (res !== null) {
        this.loing = false
        this.barOptions.series[0].data = res.data.data
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true

      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_action_xlsx,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          isPay:this.isPay,
          userType: this.userType
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, 'Live行为数据' + '')
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 40px;
  }
  
}
.el-card {
    margin:  20px 0;
    h1 {
    font-size: 28px;
    font-weight: bold;
  }
   button {
      margin-left: 30px;
    }
  }
</style>
